/**
 * Checkbox cells for the customer bulk (multi-select) appeal-response feature
 * on the Submitted Appeals table. Split out to keep AppealsSubTab under the
 * 500-line limit. Only eligible rows (supplier appeal awaiting response) render
 * a checkbox; the header offers a select-all across the page's eligible rows.
 */
import type { DeliveryAppeal } from '../../../../lib/api';
import type { AppealBulkRespond } from './useAppealBulkRespond';

const CB = 'h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer';

/** Select-all header cell. */
export function AppealSelectHeader({ bulk }: { bulk: AppealBulkRespond }) {
  return (
    <th className="text-left py-3 px-4 font-medium w-10">
      <input
        type="checkbox"
        checked={bulk.allEligibleSelected}
        onChange={bulk.toggleAll}
        disabled={bulk.eligibleAppeals.length === 0}
        className={`${CB} disabled:cursor-not-allowed disabled:opacity-40`}
        title="Select all appeals awaiting your response on this page"
      />
    </th>
  );
}

/** Per-row select cell — empty for appeals that aren't awaiting a response. */
export function AppealSelectRow({ bulk, appeal }: { bulk: AppealBulkRespond; appeal: DeliveryAppeal }) {
  return (
    <td className="py-3 px-4">
      {bulk.isEligible(appeal) ? (
        <input
          type="checkbox"
          checked={bulk.selectedIds.has(appeal.id)}
          onChange={() => bulk.toggle(appeal.id)}
          className={CB}
          title="Select this appeal"
        />
      ) : null}
    </td>
  );
}
